webpackJsonp([97339636161226],{

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// vendor
	var createContentSection = function createContentSection(children) {
	  var result = void 0;
	
	  switch (children.type) {
	    case 'ul':
	      result = _react2.default.createElement(
	        'ul',
	        { className: (0, _classnames2.default)('col__content', children.props.className) },
	        children.props.children
	      );
	      break;
	
	    default:
	      result = _react2.default.createElement(
	        'div',
	        { className: 'col__content' },
	        children
	      );
	  }
	
	  return result;
	};
	
	// vendor utils
	
	
	var Col = function Col(_ref) {
	  var children = _ref.children,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'col' },
	    _react2.default.createElement(
	      'p',
	      { className: 'col__title' },
	      title
	    ),
	    createContentSection(children)
	  );
	};
	
	Col.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired
	};
	
	exports.default = Col;
	module.exports = exports['default'];

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(15);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Col = __webpack_require__(136);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _PageTitle = __webpack_require__(16);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	__webpack_require__(618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Utils
	
	
	// vendor components
	var LesCoureursPage = function LesCoureursPage(_ref) {
	  var _ref$data = _ref.data,
	      _ref$data$site$siteMe = _ref$data.site.siteMetadata,
	      siteUrl = _ref$data$site$siteMe.siteUrl,
	      siteTitle = _ref$data$site$siteMe.title,
	      portraitMartin = _ref$data.portraitMartin.childImageSharp.sizes,
	      portraitDavid = _ref$data.portraitDavid.childImageSharp.sizes;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Les coureurs | ' + siteTitle
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'Auteurs et conf\xE9renciers maintes fois prim\xE9s pour leurs livres et leurs recherches inusit\xE9es dans le monde brassicole'
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', value: 'summary' }),
	      _react2.default.createElement('meta', {
	        property: 'og:title',
	        content: 'Les coureurs | Les coureurs des boires'
	      }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:url', content: siteUrl + '/les-coureurs' }),
	      _react2.default.createElement('meta', {
	        property: 'og:description',
	        content: 'Auteurs et conf\xE9renciers maintes fois prim\xE9s pour leurs livres et leurs recherches inusit\xE9es dans le monde brassicole'
	      }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: 'Les coureurs des boires' }),
	      _react2.default.createElement('link', { rel: 'canonical', href: siteUrl + '/les-coureurs' })
	    ),
	    _react2.default.createElement(_PageTitle2.default, { title: 'Les coureurs' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'les-coureurs' },
	      _react2.default.createElement(
	        'div',
	        { className: 'les-coureurs__content' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'les-coureurs__title' },
	          'Les Coureurs'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'les-coureurs__intro-text' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Les Coureurs des Boires, c\u2019est nous: Martin Thibault et David L\xE9vesque Gendron, deux auteurs qu\xE9b\xE9cois passionn\xE9s. Passionn\xE9s par la bi\xE8re dans son ensemble, mais principalement par sa capacit\xE9 \xE0 nous faire voyager tant de le confort de notre salon qu\u2019en des contr\xE9es o\xF9 nous ne nous rendrions pas intuitivement. Notre passe-temps favori est ultimement notre sp\xE9cialit\xE9: nous chassons les grands crus \xE0 travers le monde, combinant notre int\xE9r\xEAt pour le voyage \xE0 celui de l\u2019exploration de la gamme infinie des flaveurs de la bi\xE8re. Notre souhait le plus cher: que la bi\xE8re se trouve une place de choix sur les grandes et petites tables du Qu\xE9bec et d\u2019ailleurs. Pourquoi? Parce qu\u2019elle le m\xE9rite, et parce que nous le m\xE9ritons.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'les-coureurs__photos-section' },
	        _react2.default.createElement(
	          'figure',
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: 'les-coureurs__image',
	            sizes: portraitMartin,
	            alt: 'Portait de Martin Thibault.'
	          }),
	          _react2.default.createElement(
	            'figcaption',
	            null,
	            'Martin Thibault'
	          )
	        ),
	        _react2.default.createElement(
	          'figure',
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: 'les-coureurs__image',
	            sizes: portraitDavid,
	            alt: 'Portait de David L\xE9vesque-Gendron.'
	          }),
	          _react2.default.createElement(
	            'figcaption',
	            null,
	            'David L\xE9vesque-Gendron'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Col2.default,
	      { title: 'Publications' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Trois livres \xE0 succ\xE8s, d\xE9crits sur la page \u2018Livres\u2019 de ce site'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '5 articles vedettes dans le magazine am\xE9ricain Beer Connoisseur, dont un ayant permis \xE0 Martin de gagner un premier prix de la North American Guild of Beer Writers'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '4 articles vedettes (\xAB features \xBB) dans le magazine Beer Advocate, dont un ayant permis \xE0 Martin de gagner un autre prix de la North American Guild of Beer Writers'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Collaboration dans le Pocket Beer Guide 2013 de Tim Webb (section Lituanie)'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Quelques douzaines d\u2019articles dans le journal Bi\xE8res et plaisirs'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Quelques douzaines d\u2019articles dans le Journal de Montr\xE9al (de fa\xE7on hebdomadaire depuis 2015)'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Quelques douzaines d\u2019articles dans le d\xE9funt journal Les Carnets de ma bi\xE8re'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Une bonne douzaine d\u2019autres id\xE9es de livres \xE0 publier au fil des prochaines ann\xE9es!'
	      )
	    ),
	    _react2.default.createElement(
	      _Col2.default,
	      { title: 'Conf\xE9rences, cours, d\xE9gustations dirig\xE9es' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Dans des festivals tels Bi\xE8res et Saveurs de Chambly et l\u2019Oktoberfest de Repentigny'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pour le congr\xE8s de l\u2019Association des microbrasseries du Qu\xE9bec (AMBQ)'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pour le Master Brewers Association of the Americas (MBAA)'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pour l\u2019\xE9cole MBi\xE8re du Mondial de la Bi\xE8re'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pour le programme \u2018Sommelier-bi\xE8re\u2019 de la Cit\xE9 Coll\xE9giale, \xE0 Ottawa'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pour former des employ\xE9s de microbrasseries et de bars sp\xE9cialis\xE9s'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pour l\u2019Association des brasseurs amateurs du Qu\xE9bec (LABAQ)'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Dans plusieurs biblioth\xE8ques du Qu\xE9bec (Boucherville, Montr\xE9al, St-Jean-sur-Richelieu, etc.)'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Chez des particuliers'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'les-coureurs__others' },
	      _react2.default.createElement(
	        'div',
	        { className: 'les-coureurs__others-col les-coureurs__others-col-1' },
	        _react2.default.createElement('iframe', {
	          title: 'Vid\xE9o de pr\xE9sentation du livre \xABLes saveurs gastronomiques de la bi\xE8re\xBB.',
	          src: 'https://player.vimeo.com/video/72372393',
	          width: '640',
	          height: '360',
	          frameBorder: '0',
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'les-coureurs__others-col les-coureurs__others-col-2' },
	        _react2.default.createElement(
	          'p',
	          { className: 'les-coureurs__others-title' },
	          'Autres'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Administrateurs du contenu qu\xE9b\xE9cois du site Ratebeer.com, ayant la plus grande base de donn\xE9es brassicole au monde, depuis 15 ans'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Co-organisateurs de divers \xE9v\xE9nements, notamment les Soir\xE9es des Grands Crus au Siboire, depuis avril 2011, les Prix du Public Bi\xE8re, depuis 2015, les Meet The Brewer au Festival Bi\xE8res et Chambly, depuis 2017, et le Winter Warmer Montr\xE9al, l\u2019Hivernale des Brasseurs.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Avons creus\xE9 les sc\xE8nes brassicoles de plus de 25 pays, des grandes villes aux campagnes recul\xE9es, depuis plus de 15 ans'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Avons inspir\xE9 le New York Times \xE0 inclure la Lituanie dans les pays \xE0 visiter en 2013 gr\xE2ce \xE0 nos recherches brassicoles dans les campagnes du nord-est l\xE0-bas'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Entrevues dans les m\xE9dias: t\xE9l\xE9, journaux, magazines et radio \xE0 Radio-Canada, RDI, etc.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'IMPORTANT:'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Depuis 2016, David est co-propri\xE9taire de la Microbrasserie Vox Populi. Martin, de son c\xF4t\xE9, d\xE9veloppe une gamme de bi\xE8res traditionnelles sign\xE9e \u2018Les Coureurs des Boires\u2019 \xE0 la brasserie Oshlag.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Afin d\u2019\xE9viter tout conflit d\u2019int\xE9r\xEAt, nous nous engageons \xE0 ne jamais profiter de notre pouvoir m\xE9diatique dans le Journal de Montr\xE9al, Bi\xE8res et Plaisirs, Beer Advocate ou toute autre publication officielle, pour faire la promotion de ces brasseries.',
	          ' '
	        )
	      )
	    )
	  );
	};
	
	// styles
	
	
	// Components
	// Vendor
	var query = exports.query = '** extracted graphql fragment **';
	
	LesCoureursPage.propTypes = {
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        siteUrl: _propTypes2.default.string.isRequired,
	        title: _propTypes2.default.string.isRequired
	      })
	    })
	  }).isRequired
	};
	
	exports.default = LesCoureursPage;

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-les-coureurs-index-jsx-27395f545bda37265f5d.js